'use client';

import { useEffect } from 'react';

export default function HomePage() {
  useEffect(() => {
    const domain = window.location.href.split('.').splice(1).join('.');
    if (domain && domain.length > 0) {
      window.location.href = `https://${domain}`;
    }
  }, []);

  return <div />;
}
